const primary = '#25bdbe'

export const Styles = (props: { tabsMarginLeft?: string; id?: string }) => (
  // eslint-disable-next-line react/no-unknown-property
  <style global jsx>{`
    #${props.id} .MuiTab-root {
      text-transform: none !important;
      min-width: 72;
      font-weight: normal;
      margin-right: 10px;
    }
    #${props.id} .MuiTab-root:hover {
      color: ${primary};
      opacity: 1;
    }
    #${props.id} .MuiTab-root[aria-selected='true'] {
      color: ${primary} !important;
      font-weight: bold;
    }
    #${props.id} .MuiTab-root:focus {
      color: ${primary};
    }

    #${props.id} .MuiTab-root {
      margin-right: 0px;
    }
    #${props.id} .MuiTab-root:hover {
      background: #dbfbf7;
    }
    #${props.id} .MuiTab-root:hover span {
      color: #25bdbe;
    }
    #${props.id} .MuiTabScrollButton-root {
      transition: 200ms;
    }
    #${props.id} .MuiTabScrollButton-root.Mui-disabled {
      opacity: 0;
      width: 0;
    }
    #${props.id} .signatures-component .block-name {
      font-size: 16px;
      padding: 8px 14px;
      display: flex;
      align-items: center;
      border-radius: 4px;
      margin-bottom: 7px;
      border: 2px #d6d6d6 solid;
      background: transparent;
      color: #101212;
      font-weight: bold;
    }
    #${props.id} .signatures-component .block-name svg {
      margin-right: 10px;
    }
    #${props.id}
      .signatures-component
      .signature-block
      .signatures-in-block
      .signature-component {
      padding-bottom: 10px;
      padding-top: 4px;
      margin-bottom: 10px;
      margin-left: 46px;
    }
    #${props.id}
      .signatures-component
      .signature-block
      .signatures-in-block
      .signature-component
      b {
      margin-right: 10px;
    }
    #${props.id}
      .signatures-component
      .signature-block
      .signatures-in-block
      .signature-component:not(:last-child) {
      border-bottom: 1px #d2d2d2 solid;
    }
    #${props.id} .MuiTabs-scroller {
      margin-bottom: 0px;
      margin-left: 0px;
    }
    @media only screen and (min-width: 760px) {
      #${props.id} .MuiTabs-scroller {
        margin-left: ${props.tabsMarginLeft || '30px'};
      }
    }
    #${props.id} .primary-tabs {
      border-bottom: 1px #dedede solid;
    }
    #${props.id} .primary-tabs .MuiTabs-indicator {
      height: 3px;
      background-color: ${primary};
    }
    #${props.id} .primary-tabs button {
      opacity: 1;
      min-height: 60px;
    }
    #${props.id} .primary-tabs button span {
      color: #101212;
      font-size: 16px;
      letter-spacing: 0;
      white-space: nowrap;
    }
    #${props.id} .primary-tabs button.Mui-selected {
      background: #dbfbf7;
    }
    #${props.id} .primary-tabs button.Mui-selected span {
      color: #25bdbe;
      font-weight: bold;
    }
    #${props.id} .secondary-tabs .MuiTabs-indicator {
      height: 0px;
    }
    #${props.id} .secondary-tabs button span {
      font-size: 15px;
    }
    #${props.id} .secondary-tabs button.Mui-selected span {
      font-weight: bold;
    }
    #${props.id} .content {
      background-color: #f4f7f9;
      min-height: 350px;
      padding: 21px;
    }
    #${props.id} .content .download-button button {
      padding: 10px 20px;
      margin: 0 -20px;
    }
    #${props.id} .content .download-button button:hover {
      text-decoration: underline;
      background: #dbfbf7;
    }
    #${props.id} .content .download-button svg {
      max-height: 22px;
      margin-right: 6px;
      min-width: 20px;
    }
    #${props.id} .content .download-button button {
      font-weight: bold;
      color: ${primary};
      display: flex;
    }

    #${props.id} .content .download-button svg path {
      fill: ${primary};
    }
    @media only screen and (max-width: 760px) {
      .content {
        padding: 20px 10px;
      }
    }
    #${props.id} .content > ul {
      padding: 0px;
    }
    #${props.id} .content .MuiTreeItem-root {
      /* padding: 0 20px;
    */
    }
    #${props.id}
      .content
      .MuiTreeItem-root
      .MuiTreeItem-content
      .MuiTreeItem-iconContainer {
      margin-left: 20px;
    }
    #${props.id}
      .content
      .MuiTreeItem-root
      .MuiTreeItem-content
      .MuiTreeItem-label {
      word-wrap: break-word;
      max-width: calc(100% - 55px);
    }
    #${props.id} .content .MuiTreeItem-root .MuiTreeItem-label {
      background-color: transparent !important;
    }
    #${props.id} .content .MuiTreeItem-root svg {
      width: 30px;
      height: 30px;
      max-width: 30px;
      color: #25bdbe;
    }
    #${props.id}
      .content
      .MuiTreeItem-root[aria-expanded]
      > .MuiTreeItem-content:hover {
      cursor: pointer;
      background: #dbfbf7;
    }

    #${props.id} .content .MuiTreeItem-root > .MuiTreeItem-content {
      padding-left: 20px;
      padding-right: 20px;
    }
    #${props.id} .content .MuiTreeItem-root > .MuiTreeItem-content:hover {
      cursor: auto;
      background: #eee;
    }
    #${props.id}
      .content
      .MuiTreeItem-root
      > .MuiTreeItem-content.Mui-expanded {
      border-bottom: 2px #25bdbe solid;
      background: #dbfbf7;
    }
    #${props.id}
      .content
      .MuiTreeItem-root
      > .MuiTreeItem-content.Mui-expanded
      b {
      color: #25bdbe !important;
    }
    #${props.id} .content .MuiTreeItem-root.Mui-selected b {
      color: #25bdbe;
    }
    #${props.id} .content .MuiTreeItem-root .MuiTreeItem-content {
      padding: 6px 0;
    }
    #${props.id} .content .MuiTreeItem-root .MuiTreeItem-content.Mui-selected {
      background-color: rgb(219 251 247 / 50%);
    }
    #${props.id} .content .MuiTreeItem-root .MuiTreeItem-label > div > span,
    #${props.id} .content .MuiTreeItem-root .MuiTreeItem-label > div > b {
      font-size: 16px;
      margin-right: 10px;
      color: #101212 !important;
    }
  `}</style>
)
